// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { customCustomerAddressFormStyles } from "@steiner/App/Components/CustomCreateAccount/CustomCustomerAddressForm";
import { css } from "styled-components";

customCustomerAddressFormStyles.container = {
    gap: 15,
};
customCustomerAddressFormStyles.firstNameGridItem = { width: 6 };
customCustomerAddressFormStyles.lastNameGridItem = { width: 6 };
customCustomerAddressFormStyles.companyNameGridItem = { width: 6 };
customCustomerAddressFormStyles.attentionGridItem = { width: 6 };
customCustomerAddressFormStyles.address1GridItem = { width: 12 };
customCustomerAddressFormStyles.address2GridItem = { width: 12 };
customCustomerAddressFormStyles.address3GridItem = { width: 12 };
customCustomerAddressFormStyles.address4GridItem = { width: 12 };
customCustomerAddressFormStyles.countryGridItem = { width: 12 };
customCustomerAddressFormStyles.cityGridItem = { width: 12 };
customCustomerAddressFormStyles.stateGridItem = { width: 6 };
customCustomerAddressFormStyles.postalCodeGridItem = { width: 6 };
customCustomerAddressFormStyles.phoneGridItem = { width: 6 };
customCustomerAddressFormStyles.faxGridItem = { width: 6 };
customCustomerAddressFormStyles.emailGridItem = { width: 12 };
customCustomerAddressFormStyles.formButtonsWrapper = {
    width: 12,
    css: css`
        justify-content: space-between;
        margin-top: 5px;
        ${({ isOutsideSubmit }: any) => {
            if (isOutsideSubmit) {
                return css`
                    display: none;
                `;
            }
        }}
    `,
};
customCustomerAddressFormStyles.submitButton = {
    variant: "primary",
};
customCustomerAddressFormStyles.cancelButton = {
    variant: "secondary",
};
